import { FlexBox, IconNames, Tag } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';

import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';

import { TagModal } from '../modals/tag';
import type { AutomationFlowExtraDataT } from '../types';

import styles from './tag.module.scss';
import { TagOperation } from './types';

export type AutomationTagT = {
  id: string;
  name: string;
  color: string;
};

export type AutomationNodeTagPayloadT = {
  operation: TagOperation;
  tags: AutomationTagT[];
  nextNodeId: string;
};

export type AutomationNodeTagTypeT = AutomationNodeTypes.TAG;
export type AutomationNodeTagT = NodeT<
  AutomationNodeTagTypeT,
  AutomationNodeTagPayloadT
>;

type StateT = { nodeOverflowing: number };

const actionFormatter = (node: AutomationNodeTagT): Array<RegisterPortT> => [
  {
    id: uuid(),
    type: 'out',
    label: 'arrow',
    connection: node.payload.nextNodeId || uuid(),
  },
];

export class TagNode extends NodeTypeComponent<
  AutomationNodeTagT,
  AutomationFlowExtraDataT,
  StateT
>() {
  static icon: IconNames = 'tag';
  static label = 'Add / Remove tag';
  static color = flowNodeColor.blue;
  static translatePayload = formatPortsHelper(actionFormatter);
  static ActionModal = TagModal;
  static actionTrigger = { type: AutomationNodeTypes.TAG };
  static updateConnection = (
    node: AutomationNodeTagT,
    _port: InternalPortT,
    newConnection: string,
  ): AutomationNodeTagT => {
    const payload = { ...node.payload };
    payload.nextNodeId = newConnection;
    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    const {
      node: {
        payload: { operation, tags },
      },
    } = this.props;
    const { color, name } = tags[0];

    return (
      <FlowNode
        color={TagNode.color}
        icon={TagNode.icon}
        label={operation === TagOperation.TAG ? 'Add tag' : 'Remove tag'}
        text={
          <FlexBox alignItems="center" justifyContent="space-between">
            <Tag key={name} className={styles.tag} color={color} noBorder>
              {name}
            </Tag>
            {tags.length > 1 && (
              <span className={styles.tagsNumber}>+{tags.length - 1}</span>
            )}
          </FlexBox>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
